import { useClickAway, useToggle } from 'ahooks'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { UserAvatar, UsersSearch } from '@/components'

import s from './click-away.module.less'

export const ClickAwayUserSearch: React.FC<{
  required: boolean
  value: string
  includeEmails?: { email: string }[]
  readonly?: boolean
  isActive?: boolean
  onChange: (value: any) => void
}> = ({ value, readonly, required, isActive, includeEmails, onChange }) => {
  const { t } = useTranslation()
  const [isEditing, { toggle }] = useToggle(!!isActive)
  const ref = React.useRef<HTMLDivElement>(null)

  useClickAway(() => {
    if (!isActive) {
      toggle(false)
    }
  }, [ref])

  return (
    <div ref={ref}>
      {isEditing && !readonly ? (
        <UsersSearch
          includeEmails={includeEmails}
          status={required && !value ? 'error' : undefined}
          style={{ width: '100%' }}
          value={value || undefined}
          onChange={onChange}
          placeholder={t('search users')}
        />
      ) : value ? (
        <div
          className={s.subElementCursorPointer}
          onClick={(e) => {
            e.stopPropagation()
            toggle(true)
          }}
        >
          <UserAvatar size={20} showName email={value} />
        </div>
      ) : (
        <div>待确认</div>
      )}
    </div>
  )
}
